import {
  IItem,
  IEmptyValidatable,
} from "../items";
import { AbstractEmptyAlert } from "./AbstractEmptyAlert";

export class SingleEmptyAlert extends AbstractEmptyAlert<IItem & IEmptyValidatable> {
  constructor(itemSetId: number, item: IItem & IEmptyValidatable) {
    super(itemSetId, item, !item.enableEmptyCheckConfirmation);
  }

  get kind(): string {
    return "単体警告";
  }

  protected get itemName(): string {
    return this.getDisplayName(this._detectedItem);
  }

  private getDisplayName(item: IEmptyValidatable): string {
    if (!item) {
      throw new Error("item is empty!!!");
    }
    const anyItem = item as any;
    // TODO:implement interface
    if (anyItem.isHisInfo) {
      return anyItem.displayName;
    }
    // TODO:implement interface
    if (anyItem.userDefinitionKey) {
      return anyItem.itemName;
    }
    // TODO:implement interface
    if (anyItem.name) {
      return anyItem.name;
    }
    return anyItem.id;
  }
}
